import Vue from "vue";
import Router from "vue-router";

Vue.use(Router);

const router = new Router({
  mode: 'hash',
  routes: [
    { path: '/', name: 'MainActivity', component: () => import('@/app/activity/MainActivity.vue') },
    { path: '/login', name: 'Forbidden', component: () => import('@/app/activity/LoginActivity.vue') },
    { path: '/delivery/:context/list', name: 'DeliveryListActivity', component: () => import('@/app/activity/DeliveryListActivity.vue') },
    { path: '/delivery/:context/report', name: 'DeliveryReportActivity', component: () => import('@/app/activity/DeliveryReportActivity.vue') },
    { path: '/delivery/:context/:id', name: 'DeliveryActivity', component: () => import('@/app/activity/DeliveryActivity.vue') },
    { path: '/delivery/:context/:id/pdf', name: 'DeliveryPDFActivity', component: () => import('@/app/activity/DeliveryPDFActivity.vue') }
  ]
})

router.beforeEach(async (to, from, next) => {
  document.body.style.overflow = 'inherit'
  // TODO: verify token offline
    // if (to.name !== 'Forbidden') {
    //   await Store.dispatch('AUTH_ISAUTHENTICATED', null, {root: true});
    // }
    next();
  }
)

export default router
